import React, { memo, useCallback, useEffect, useState, useRef } from 'react';
import classes from './ProductSelection.module.css';
import { Box, Paper, Select, SimpleGrid, Space, Text, TextInput } from '@mantine/core';
// import { useParams } from 'react-router-dom';
import { IoAddOutline, IoTrashOutline } from "react-icons/io5";
import { baseUrl } from '../../../../../Constants/constant';
import useFetch from '../../../../../Customhooks/useFetch';
import TransportProduct from './TransportProduct.component';

interface TransportField {
    id_comp_trans: number;
    id: number | null;
    sourcelocation_id: string;
    source_place_id: string;
    transportType_id: string | null;
    destinationlocation_name: string;
    destination_place_id: string;
    distance: any;
}

interface FormField {
    id_comp: number;
    id: number | null;
    factory_name: string | null;
    vertical_id: string | null;
    material_name: string | null;
    materialSub_type_name: string | null;
    process: string;
    weight: string;
    percentage: string;
    gsm_size: string;
    sheet_size_height: string;
    sheet_size_width: string;
    no_of_product: string;
    // no_of_layers: string;
    // glue_Co2: string;
    // coverage: string;
    // ink_co2: string;
    weight_type: string;
    transportData?: TransportField[];
}

interface SelectOption {
    value: string;
    label: string;
}
interface ProductCharacteristicsProps {
    onFieldsChange: (fields: FormField[]) => void;
    onValidationChange: (isValid: boolean) => void;
    showErrors: boolean;
    initialFields?: FormField[];
    gsm: any;
    computeId: number;
    id_p: number;
}

const ProductAddMoreDetail: React.FC<ProductCharacteristicsProps> = ({
    onFieldsChange,
    onValidationChange,
    showErrors,
    initialFields,
    gsm,
    computeId,
    id_p
}) => {
    const verticalId = sessionStorage.getItem("selectedVerticalId");
    const [verticals, setVerticals] = useState<SelectOption[]>([]);
    const [rawMaterial, setRawMaterial] = useState<SelectOption[]>([]);
    const [materialSub, setMaterialSub] = useState<SelectOption[]>([]);
    const [factory, setFactory] = useState<any>();
    const [subTypeDetails, setSubTypeDetails] = useState<Record<string, any>>({});
    const [errors, setErrors] = useState<Record<string, string>>({});
    const [fields, setFields] = useState<FormField[]>([{
        id_comp: 1,
        id: null,
        factory_name: null,
        vertical_id: verticalId || null,
        material_name: null,
        materialSub_type_name: null,
        process: '',
        weight: "",
        percentage: "",
        gsm_size: "",
        sheet_size_height: "",
        sheet_size_width: "",
        no_of_product: "",
        // no_of_layers: "",
        // glue_Co2: "",
        // coverage: "",
        // ink_co2: "",
        weight_type: "",
        transportData: []
    }]);

    // const { id } = useParams();
    const token = localStorage.getItem("token");
    const prevFieldsRef = useRef<string | null>(null);
    const apiCallsRef = useRef<Set<string>>(new Set());

    const fetchConfig = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            token: token,
        },
    };

    const { data: getVerticalData, fetchData: getVerticals } = useFetch(fetchConfig);
    const { data: getRawMaterialData, fetchData: getRawMaterial } = useFetch(fetchConfig);
    const { data: getMaterialSubTypeData, fetchData: getMaterialSubType } = useFetch(fetchConfig);
    const { data: getFactoryData, fetchData: getFactory } = useFetch(fetchConfig);

    useEffect(() => {

        const fieldsString = JSON.stringify(fields);
        if (prevFieldsRef.current === fieldsString) {
            return;
        }

        prevFieldsRef.current = fieldsString;

        const debounce = setTimeout(() => {
            onFieldsChange(fields);
            const isValid = validateFields();
            onValidationChange(isValid);
        }, 300);

        return () => clearTimeout(debounce);
    }, [fields, showErrors]);

    useEffect(() => {
        getVerticals(`${baseUrl}admin/verticals`);
        getFactory(`${baseUrl}admin/factories`);
    }, []);
    useEffect(() => {
        if (verticalId && !initialFields?.length) {
            getRawMaterial(`${baseUrl}admin/raw-materials?vertical_id=${verticalId}`);
        }
    }, [verticalId]);

    useEffect(() => {
        if (getVerticalData?.data?.rows) {
            const verticalOptions = getVerticalData?.data?.rows?.map((el: any) => ({
                value: el?.vertical_id.toString(),
                label: el?.vertical_name,
            }));
            setVerticals(verticalOptions);
        }
    }, [getVerticalData]);
    useEffect(() => {
        if (getFactoryData?.data?.rows) {
            setFactory(
                getFactoryData?.data?.rows?.map((el: any) => ({
                    value: el?.id.toString(),
                    label: el?.factory_name,
                }))
            );
        }
    }, [getFactoryData]);

    useEffect(() => {
        if (getRawMaterialData?.data?.rows) {
            setRawMaterial(getRawMaterialData?.data?.rows?.map((el: any) => ({
                value: el?.id.toString(),
                label: el?.material_name,
            })));
        }
    }, [getRawMaterialData]);

    useEffect(() => {
        if (getMaterialSubTypeData?.data?.rows) {
            setMaterialSub(getMaterialSubTypeData?.data?.rows?.map((el: any) => ({
                value: el?.id.toString(),
                label: el?.sub_name,
            })));

            const SubTypeDetailsMap = getMaterialSubTypeData.data.rows.reduce((acc: Record<string, any>, el: any) => {
                acc[el.id.toString()] = el;
                return acc;
            }, {});
            setSubTypeDetails(SubTypeDetailsMap);
        }
    }, [getMaterialSubTypeData]);

    const memoizedFields = React.useMemo(() => {
        if (!initialFields || initialFields?.length === 0) return [];
        return initialFields?.map(field => ({
            ...field,
            factory_name: field?.factory_name?.toString() || null,
            vertical_id: field?.vertical_id?.toString() || null,
            material_name: field?.material_name?.toString() || null,
            materialSub_type_name: field?.materialSub_type_name?.toString() || null,
            weight: field?.weight?.toString() || "",
            percentage: field?.percentage?.toString() || "",
            process: field?.process?.toString() || "",
            gsm_size: field?.gsm_size?.toString() || "",
            sheet_size_height: field?.sheet_size_height?.toString() || "",
            sheet_size_width: field?.sheet_size_width?.toString() || "",
            no_of_product: field?.no_of_product?.toString() || "",
            // no_of_layer: field?.no_of_layers?.toString() || "",
            // glue_type_co2: field?.glue_Co2?.toString() || "",
            // coverage: field?.coverage?.toString() || "",
            // ink_type_co2: field?.ink_co2?.toString() || "",
            transportData: field?.transportData?.map((transport, index) => ({
                id_comp_trans: index + 1,
                id: transport?.id || null,
                sourcelocation_id: transport?.sourcelocation_id || "",
                source_place_id: transport.source_place_id || '',
                transportType_id: transport?.transportType_id || null,
                destinationlocation_name: transport?.destinationlocation_name || "",
                destination_place_id: transport.destination_place_id || '',
                distance: transport.distance || ''
            })) || []
        }));
    }, [initialFields]);

    useEffect(() => {
        if (!initialFields || initialFields.length === 0) return;

        initialFields?.forEach(field => {
            if (field?.vertical_id) {
                const apiKey = `raw-materials-${field?.vertical_id}`;
                if (!apiCallsRef?.current.has(apiKey)) {
                    apiCallsRef?.current.add(apiKey);
                    getRawMaterial(`${baseUrl}admin/raw-materials`);
                    // getRawMaterial(`${baseUrl}admin/raw-materials?vertical_id=${field.vertical_id}`);
                }
            }
            if (field?.material_name) {
                const apiKey = `material-subtypes-${field?.material_name}`;
                if (!apiCallsRef?.current.has(apiKey)) {
                    apiCallsRef?.current.add(apiKey);
                    getMaterialSubType(`${baseUrl}admin/raw-material-sub-types`);
                    // getMaterialSubType(`${baseUrl}admin/raw-material-sub-types?material_id=${field?.material_name}`);
                }
            }
        });
    }, [initialFields]);

    useEffect(() => {
        // @ts-ignore
        if (computeId > 0 && initialFields?.length > 0) {
            setFields(memoizedFields);
        }
    }, [computeId, initialFields]);

    useEffect(() => {
        // @ts-ignore
        if (computeId <= 0 && id_p && initialFields?.length > 0) {
            setFields(memoizedFields);
        }
    }, [id_p, initialFields, computeId]);

    const validateFields = () => {
        const newErrors: Record<string, string> = {};
        let isValid = true;

        fields?.forEach((field, index) => {
            if (!field?.vertical_id) {
                newErrors[`vertical_id_${index}`] = "Vertical is required";
                isValid = false;
            }
            if (!field?.factory_name) {
                newErrors[`factory_name${index}`] = "Factory Name is required";
                isValid = false;
            }
            if (!field?.material_name) {
                newErrors[`material_name_${index}`] = "Material is required";
                isValid = false;
            }
            if (!field?.materialSub_type_name) {
                newErrors[`materialSub_type_name_${index}`] = "Sub-type is required";
                isValid = false;
            }
        });

        setErrors(newErrors);
        onValidationChange(isValid);
        return isValid;
    };

    const handleChange = useCallback((index: number, field: keyof FormField, value: string | null) => {
        setFields(prevFields => {
            const newFields = [...prevFields];

            newFields[index] = {
                ...newFields[index],
                [field]: value
            };

            if (field === 'vertical_id') {
                newFields[index] = {
                    ...newFields[index],
                    material_name: null,
                    materialSub_type_name: null,
                };

                if (value) {
                    // const apiKey = `raw-materials-${value}`;
                    // if (!apiCallsRef.current.has(apiKey)) {
                    //     apiCallsRef?.current.add(apiKey);
                    getRawMaterial(`${baseUrl}admin/raw-materials?vertical_id=${value}`);
                    // }
                }
            } else if (field === 'material_name') {
                newFields[index] = {
                    ...newFields[index],
                    materialSub_type_name: null
                };


                if (value) {
                    // const apiKey = `material-subtypes-${value}`;
                    // if (!apiCallsRef.current.has(apiKey)) {
                    //     apiCallsRef?.current.add(apiKey);
                    getMaterialSubType(`${baseUrl}admin/raw-material-sub-types?material_id=${value}`);
                    // }
                }
            }
            if (field === 'materialSub_type_name' && value) {
                const selectedSubType = subTypeDetails[value];
                if (selectedSubType) {
                    newFields[index].process = selectedSubType?.Process?.process_name || "";
                    newFields[index].weight_type = selectedSubType?.Weighttype?.weight_name || "";
                }
            }

            return newFields;
        });
    }, [getRawMaterial, getMaterialSubType]);

    const addComponent = useCallback(() => {
    // Reset all errors
    setErrors({});

    setFields(prev => [...prev, {
        id_comp: prev.length + 1,
        id: null,
        factory_name: null,
        vertical_id: verticalId || null, // Use the verticalId from localStorage
        material_name: null,
        materialSub_type_name: null,
        process: "",
        weight: "",
        percentage: "",
        gsm_size: "",
        sheet_size_height: "",
        sheet_size_width: "",
        no_of_product: "",
        // no_of_layers: "",
        // glue_Co2: "",
        // coverage: "",
        // ink_co2: "",
        weight_type: "",
        transportData: []
    }]);
}, [verticalId]);

    const handleDeleteComponent = useCallback((index: number) => {
        if (fields?.length <= 1) {

            return;
        }

        setFields(prev => prev.filter((_, i) => i !== index));


        setTimeout(() => validateFields(), 0);
    }, [fields?.length]);

    const handleTransportDataChange = useCallback((transportFields: TransportField[], parentIndex: number) => {
        setFields(prevFields => {

            const currentTransport = JSON.stringify(prevFields[parentIndex]?.transportData || []);
            const newTransport = JSON.stringify(transportFields);

            if (currentTransport === newTransport) {
                return prevFields;
            }

            const newFields = [...prevFields];
            newFields[parentIndex] = {
                ...newFields[parentIndex],
                transportData: transportFields,
            };

            return newFields;
        });
    }, []);

    return (
        <>
            {fields?.map((field, index) => (
                <Paper className={classes.productdiv} key={index} shadow="xs" p="xs" radius="md" mb={10}>
                    <Space />
                    {fields?.length > 1 && <Box className={classes.delete_box} ><IoTrashOutline fill='red' size={20} onClick={() => handleDeleteComponent(index)} /></Box>}
                    <Box ml={5}>
                        <SimpleGrid cols={3}>
                            <Select
                                label="Select Factory"
                                placeholder="Select Factory"
                                withAsterisk
                                variant="filled"
                                data={factory}
                                name='factory_name'
                                searchable
                                maxDropdownHeight={200}
                                comboboxProps={{ withinPortal: false, shadow: 'md' }}
                                value={field?.factory_name}
                                onChange={(value) => handleChange(index, "factory_name", value)}
                                radius={6}
                                error={showErrors ? errors[`factory_name${index}`] : null}
                            />
                            <Select
                                label="Select Category"
                                withAsterisk
                                placeholder="Choose Category"
                                data={verticals}
                                variant="filled"
                                searchable
                                radius={6}
                                comboboxProps={{ withinPortal: false, shadow: 'md' }}
                                maxDropdownHeight={200}
                                name='vertical_id'
                                value={field?.vertical_id}
                                onChange={(value) => handleChange(index, "vertical_id", value)}
                                error={showErrors ? errors[`vertical_id_${index}`] : null}
                            />
                            <Select
                                label="Select Raw Materials"
                                withAsterisk
                                variant="filled"
                                placeholder="Select Raw Material"
                                data={rawMaterial}
                                searchable
                                maxDropdownHeight={200}
                                name='material_name'
                                value={field?.material_name}
                                comboboxProps={{ withinPortal: false, shadow: 'md' }}
                                onChange={(value) => handleChange(index, "material_name", value)}
                                disabled={!field?.vertical_id}
                                radius={6}
                                error={showErrors ? errors[`material_name_${index}`] : null}
                            />
                            <Select
                                label="Select Material Sub Type"
                                withAsterisk
                                variant="filled"
                                placeholder="Select Material Sub Type"
                                data={materialSub}
                                searchable
                                maxDropdownHeight={200}
                                comboboxProps={{ withinPortal: false, shadow: 'md' }}
                                name='materialSub_type_name'
                                value={field?.materialSub_type_name}
                                onChange={(value) => handleChange(index, "materialSub_type_name", value)}
                                disabled={!field?.material_name}
                                radius={6}
                                error={showErrors ? errors[`materialSub_type_name_${index}`] : null}
                            />
                            <TextInput
                                label="Process"
                                variant="filled"
                                disabled
                                value={field?.process}
                            />
                            {field.weight_type === "WEIGHT" && <><TextInput
                                label="Weight (g)"
                                placeholder="Weight"
                                variant="filled"
                                name='weight'
                                value={field?.weight || ''}
                                onChange={(e) => handleChange(index, "weight", e.target.value)}
                            />
                                <TextInput
                                    label="Percentage (%)"
                                    placeholder="Percentage"
                                    variant="filled"
                                    name='percentage'
                                    value={field?.percentage || ''}
                                    onChange={(e) => handleChange(index, "percentage", e.target.value)}
                                    error={showErrors ? errors[`percentage_${index}`] : null}
                                /></>}
                            <TextInput
                                onChange={(e) => handleChange(index, "id", e.target.value)}
                                style={{ display: 'none' }}
                            />
                            {field.weight_type === "GSM" && <>
                                <TextInput
                                    label="GSM size"
                                    withAsterisk
                                    placeholder="Enter Gsm size"
                                    variant="filled"
                                    name='gsm_size'
                                    value={field?.gsm_size || ''}
                                    onChange={(e) => handleChange(index, "gsm_size", e.target.value)}
                                    error={showErrors ? errors[`gsm_size${index}`] : null}
                                />
                                <TextInput
                                    label="Sheet height (mm)"
                                    withAsterisk
                                    placeholder="Enter Sheet size"
                                    variant="filled"
                                    value={field?.sheet_size_height || ''}
                                    onChange={(e) => handleChange(index, "sheet_size_height", e.target.value)}
                                    error={showErrors ? errors[`sheet_size_height${index}`] : null}
                                />
                                <TextInput
                                    label="Sheet width (mm)"
                                    withAsterisk
                                    placeholder="Enter Sheet size"
                                    variant="filled"
                                    value={field?.sheet_size_width || ''}
                                    onChange={(e) => handleChange(index, "sheet_size_width", e.target.value)}
                                    error={showErrors ? errors[`sheet_size_width${index}`] : null}
                                />
                                <TextInput
                                    label="Number of Products"
                                    withAsterisk
                                    placeholder="Enter Number of Products"
                                    variant="filled"
                                    value={field?.no_of_product || ''}
                                    onChange={(e) => handleChange(index, "no_of_product", e.target.value)}
                                    error={showErrors ? errors[`no_of_product${index}`] : null}
                                />
                            </>}
                        </SimpleGrid>

                        {/* {field.weight_type === "GSM" && <><Space h="sm" /><SimpleGrid cols={4}>
                            <TextInput
                                label="No of layers"
                                withAsterisk
                                placeholder="Enter no of layers"
                                variant="filled"
                                value={field?.no_of_layers || ''}
                                onChange={(e) => handleChange(index, "no_of_layers", e.target.value)}
                                error={showErrors ? errors[`no_of_layers${index}`] : null}
                            />
                            <TextInput
                                label="Glue Type Co2 per cm"
                                withAsterisk
                                placeholder="Enter Co2 per cm"
                                variant="filled"
                                value={field?.glue_Co2 || ''}
                                onChange={(e) => handleChange(index, "glue_Co2", e.target.value)}
                                error={showErrors ? errors[`glue_Co2${index}`] : null}
                            />
                            <TextInput
                                label="Coverage %"
                                withAsterisk
                                placeholder="Enter Sheet size"
                                variant="filled"
                                value={field?.coverage || ''}
                                onChange={(e) => handleChange(index, "coverage", e.target.value)}
                                error={showErrors ? errors[`coverage${index}`] : null}
                            />
                            <TextInput
                                label="Ink Type Co2 per cm"
                                withAsterisk
                                placeholder="Enter Number of Products"
                                variant="filled"
                                value={field?.ink_co2 || ''}
                                onChange={(e) => handleChange(index, "ink_co2", e.target.value)}
                                error={showErrors ? errors[`ink_co2${index}`] : null}
                            />
                        </SimpleGrid>
                        </>} */}
                        <Space h="lg" />
                        <TransportProduct
                            onTransportFieldsChange={(transportFields) => handleTransportDataChange(transportFields, index)}
                            parentIndex={index}
                            initialFields={field?.transportData}
                            showErrors={showErrors}
                            computeId={computeId}
                        />
                        <Space h="sm" />
                    </Box>
                </Paper>
            ))}
            <Space h="sm" />
            <Box className={classes.addmoreleg}>
                <span style={{ display: 'flex' }}><IoAddOutline size={18} /></span>
                <Text
                    variant="default"
                    onClick={addComponent}
                    ta="right"
                    pl={4}
                >
                    Add More Component
                </Text>
            </Box>
            <Space h="sm" />
        </>
    );
};

export default memo(ProductAddMoreDetail);